<template lang='pug'>
    v-dialog(:persistent="reloginNotif" v-model="dialog" id="modal" transition="dialog-bottom-transition" width="40%" class="test-dialog")
        template(slot="activator" v-if="imId == 'menu'")
            v-list-tile(active-class='secondary--text')
                v-list-tile-action
                    v-icon(color="white") library_add
                v-list-tile-content
                    v-list-tile-title Create New requests
        template(slot="activator" v-if="imId == 'button'")
            v-btn(class="text-xs-center" color="primary" icon dark)
                v-icon add
        v-card(class="dialog-card" v-if="alert != true" v-show="reloginNotif")
            v-card-title(class="headline grey lighten-2"
            primary-title) Alert
            v-card-text
              h3(style="text-align: center; font-weight:normal;") Untuk proses pengkinian data, mohon untuk Relogin iMemo
              v-card-actions
                v-spacer
                v-btn(color="blue darken-1" flat="flat" to='/logout') OK
        v-card(class="dialog-card" v-if="alert != true && reloginNotif != true" v-show="isReady2")
            v-card-title(class="headline grey lighten-2"
            primary-title) Alert
            v-card-text
              h3(style="text-align: center; font-weight:normal;") Konfirmasi atasan langsung Anda saat ini adalah
              h3(style="text-align: center;" class="font-weight-bold") {{ supervisor }}
              h3(style="text-align: center; font-weight:normal;") Jika benar, silakan melanjutkan membuat iMemo baru.
              h3(style="text-align: center; font-weight:normal;") Jika salah, mohon email ke
              a(href = "mailto:helpdesk@samantha.id?subject = &body = ")
                h3(style="text-align: center; font-weight:normal;") helpdesk@samantha.id
              h3(style="text-align: center; font-weight:normal;") untuk update atasan Anda terlebih dahulu.
              v-card-actions
                v-spacer
                v-btn(color="blue darken-1" flat="flat" @click="alert = true") Lanjut
                v-btn(color="green darken-1" flat="flat" @click="dialog = false") Tutup
        v-card(class="dialog-card" v-if="alert != true && reloginNotif != true" v-show="isReady")
            v-card-title(class="headline grey lighten-2"
            primary-title) Alert
            v-card-text
              h3(style="text-align: center; font-weight:normal;") Data diri anda berhasil diperbaharui berdasarkan FIORI,
              h3(style="text-align: center; font-weight:normal;") atasan Anda saat ini
              h3(style="text-align: center;" class="font-weight-bold") {{ supervisor }}.
              h3(style="text-align: center; font-weight:normal;") Jika benar, silakan melanjutkan membuat iMemo.
              h3(style="text-align: center; font-weight:normal;") Jika salah, mohon email ke
              a(href = "mailto:wecare@samantha.id?subject = &body = ")
                h3(style="text-align: center; font-weight:normal;") wecare@samantha.id
              h3(style="text-align: center; font-weight:normal;") untuk update Direct SPV Anda di FIORI.
              v-card-actions
                v-spacer
                v-btn(color="blue darken-1" flat="flat" @click="alert = true") Lanjut
                v-btn(color="green darken-1" flat="flat" @click="dialog = false") Tutup
        v-card(class="dialog-card" v-if="alert == true")
            v-card-title(class="headline grey lighten-2"
            primary-title) Pilih Jenis i-Memo
            v-card-text
              v-radio-group(v-model='group')
                v-radio(label='Berau Coal Group' value='bcg')
                v-radio(label='GEMS Group' value='gems')
                v-radio(label='Non Group & Shared Services' value='nongroup')
              v-select(
                label="Pilih Company"
                :items="dataCompanies"
                v-model="company"
                item-text="name"
                item-value="name"
                hint="Mandatory"
                persistent-hint
              )
                template(slot="selection" slot-scope="data")
                  v-flex(class='ml-1')
                    span {{ data.item.name }}
                template(slot="item" slot-scope="data")
                  v-list-tile-content
                    v-list-tile-title(v-html="data.item.name")
              v-select(
                :items="jenis"
                v-model="select"
                label="Pilih Jenis Request"
                item-text="name_text"
                item-value="val"
                hint="Mandatory"
                persistent-hint
              )
            v-card-actions
                v-spacer
                v-btn(color="blue darken-1" flat="flat" @click="ngRedirect" :disabled='!isComplete') Submit
                v-btn(color="green darken-1" flat="flat" @click="dialog = false; resetAlert() ") Tutup
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
  export default {
    name: 'modal',
    props: {
        imId: String,
        menuText: 'Create New requests',
        allowedUserType: [1,2,4],
        listType: String,
    },
    data: () => ({
        dialog: false,
        alert: false,
        group: 'bcg',
        select: null,
        isReady:false,
        isReady2:false,
        company: '',
        supervisor: '',
        dataCompanies: [],
        jenis: [
            { name_text: 'IM Budget', val: 'im-budget' },
            { name_text: 'IM General', val: 'im-non-budget' },
            { name_text: 'IM Announcement', val: 'im-announcement' },
            { name_text: 'Document Percepatan Pembayaran', val: 'im-treasury' }
          ],
        reloginNotif: false,
    }),
    async mounted () {
      // this.group = this.$store.state.isImGroup ? this.group : 'nongroup';
      this.dataCompanies = await this.getCompanies(this.group);
      this.supervisor = this.$store.state.dataUsers.nama_supervisor;
      // if(!this.supervisor) {
        // this.alert = true;
      // }
      this.checkLogin();
    },
    computed: {
      ...mapState(["API_URL"]),
      isComplete: function() {
        return !!this.select && !!this.company;
      },
    },
    methods: {
      resetAlert() {
        if(this.supervisor) {
          this.alert = false
        }
      },
      getCompanies: async function(group) {
          const config = {
            method: "get",
            url: `${this.API_URL}/api/companies?by=${JSON.stringify({"group":group})}`,
            auth: {
              username: 'imemo',
              password: 'Ang3lT3n4n!#'
            }
          };
          const dataComp = await axios(config);
          return dataComp.data;
      },
      ngRedirect: function() {
        if (this.group === 'nongroup') this.$router.push(`/${this.select}?ng=1&company=${this.company}`);
        else {
          if (this.group === 'gems') this.$router.push(`/${this.select}?g=1&company=${this.company}`);
          else this.$router.push(`/${this.select}?&company=${this.company}`);
        }
        this.dialog = false;
        this.select = {};
        this.company = '';
        if (this.select === 'internal-memo' || this.select === 'im-non-budget') location.reload();
      },
      checkLogin: function() {
        let lastLogin = this.$store.state.dataUsers.last_login;
        let hoursLogin = 0;
        if(lastLogin && lastLogin !== null && lastLogin !== '' && lastLogin !== undefined){
          hoursLogin = Math.abs(new Date() - new Date(lastLogin) )/ 36e5;
        }
        if(hoursLogin > 24 || !lastLogin || lastLogin === null || lastLogin === '' || lastLogin === undefined){
          this.reloginNotif = true
        }
      }
    },
    watch: {
      dialog(val){
        if(val){
          this.checkLogin();
          if(this.reloginNotif !== true){
            this.$store.dispatch('updateData',{payload:this.$store.state.dataUsers})
            .then(response=>{
              if(response.data.message || response.data == "Pass") return this.isReady2=true;
              response = response.data

              this.$store.state.dataUsers.fullname = response.FullName
              this.$store.state.dataUsers.nik ? this.$store.state.dataUsers.nik = response.UserName : this.$store.state.dataUsers._id = response.UserName
              this.$store.state.dataUsers.title = response.PositionName
              this.$store.state.dataUsers.unit = response.BusinessUnitGroupName
              this.$store.state.dataUsers.department = response.DepartmenName
              this.$store.state.dataUsers.work_location = response.WorkLocationName
              this.$store.state.dataUsers.nama_supervisor = response.SpvName
              this.supervisor= response.SpvName

              if(this.$store.state.dataUsers.nik_supervisor != "MSPV"){
                if(response.updateToMSPV){
                  this.$store.state.dataUsers.nik_supervisor = "MSPV"
                }else{
                  this.$store.state.dataUsers.nama_supervisor = response.SpvName
                  this.$store.state.dataUsers.nik_supervisor = response.SpvNik
                  this.supervisor= response.SpvName
                }
              }
              this.isReady=true
            })
            .catch(err => {
              this.isReady2=true
            })
            // console.log(this.$store.state.dataUsers)
          }
        }else{
          this.isReady = false
          this.isReady2 = false
        }
      },
      dialog2 (val) {
        if(this.$route.path == '/my-forex-request'){
          if (!val) return
          setTimeout(() => {
            axios.put(`${this.API_URL}/forex/withdraw/requests`, {_id: this.imId}).then(() => {
                this.dialog = false;
                location.reload();
              });
            }, 
          1000)
        } else {
          if (!val) return
          setTimeout(() => {
            axios.put(`${this.API_URL}/api/withdraw/requests`, {_id: this.imId}).then(() => {
                this.dialog = false;
                location.reload();
              });
            }, 
          1000)
        }
      },
      async group(value) {
        this.select = null;
        this.company = '';
        this.dataCompanies = await this.getCompanies(value);
        this.jenis = [
          { name_text: 'IM Budget', val: 'im-budget' },
          { name_text: 'IM General', val: 'im-non-budget' },
          { name_text: 'IM Announcement', val: 'im-announcement' },
          { name_text: 'Document Percepatan Pembayaran', val: 'im-treasury' }
        ];
        if (value === 'gems') {
          this.jenis = [
            { name_text: 'Internal Memo', val: 'internal-memo' },
            { name_text: 'IM Announcement', val: 'im-announcement' },
            { name_text: 'IM Budget', val: 'im-budget' }
          ];
        } else if (value === 'nongroup') {
          this.jenis = [
            { name_text: 'Internal Memo', val: 'internal-memo' }
          ];
        }
      }
    }
  };


</script>

<style>
  .modal-backdrop {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.3);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .modal {
    background: #FFFFFF;
    box-shadow: 2px 2px 20px 1px;
    overflow-x: auto;
    display: flex;
    flex-direction: column;
  }

  .modal-header,
  .modal-footer {
    padding: 15px;
    display: flex;
  }

  .modal-header {
    border-bottom: 1px solid #eeeeee;
    color: #4AAE9B;
    justify-content: space-between;
  }

  .modal-footer {
    border-top: 1px solid #eeeeee;
    justify-content: flex-end;
  }

  .modal-body {
    position: relative;
    padding: 20px 10px;
  }

  .btn-close {
    border: none;
    font-size: 20px;
    padding: 20px;
    cursor: pointer;
    font-weight: bold;
    color: #4AAE9B;
    background: transparent;
  }

  .btn-green {
    color: white;
    background: #4AAE9B;
    border: 1px solid #4AAE9B;
    border-radius: 2px;
  }
</style>

    